import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/forms/careerForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/forms/generalForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/forms/homepageForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/forms/resourceForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/forms/servicesForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/corporate-nextjs/src/components/googleCaptchaWrapper.tsx");
